import React, { useRef, useEffect, useState, FC } from 'react';
import { Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import VideoIcon from '../../../../../assets/img/icons/video-camera-white.svg';

interface Props {
    text: string;
    handleSubmit: (file: File) => void;
    specialIcon?: string;
}

const UploadVideoActionButton: FC<Props> = ({ text, handleSubmit, specialIcon }) => {
    const actionButtonInputReference = useRef<HTMLInputElement>(null);
    const [actionButtonIcon, setActionButtonIcon] = useState(VideoIcon);

    useEffect(() => {
        if (specialIcon) {
            setActionButtonIcon(specialIcon);
        }
    }, [specialIcon]);

    const onFileChange = (data: React.ChangeEvent<HTMLInputElement>) => {
        if (data.target.files) handleSubmit(data.target.files?.[0]);
    };

    const handleActionClick = () => {
        actionButtonInputReference.current?.click();
    };

    return (
        <div>
            <Action
                style={{
                    backgroundColor: '#ff5a60',
                    outline: 'none',
                }}
                text={text}
                onClick={handleActionClick}
            >
                <img
                    style={{
                        width: 30,
                    }}
                    src={actionButtonIcon}
                    alt=""
                />
            </Action>

            <input
                type="file"
                ref={actionButtonInputReference}
                style={{ display: 'none' }}
                onChange={onFileChange}
            />
        </div>
    );
};

export default UploadVideoActionButton;
